import axios from "src/lib/axios";

// Get all certificates
export const getCertificatesList = async (params = {}) => {
  try {
    const response = await axios.get("/certificates", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get certificate by ID
export const getCertificateDetail = async (id) => {
  try {
    const response = await axios.get(`/certificate/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create new certificate
export const createCertificate = async (data) => {
  try {
    const response = await axios.post("/certificate", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update certificate
export const updateCertificate = async (id, data) => {
  try {
    const response = await axios.put(`/certificate/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete certificate
export const deleteCertificate = async (id) => {
  try {
    const response = await axios.delete(`/certificate/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update certificate status
export const updateCertificateStatus = async (id, status) => {
  try {
    const response = await axios.patch(`/certificate/${id}/status`, { status });
    return response.data;
  } catch (error) {
    throw error;
  }
};